import { render, staticRenderFns } from "./GestioneCorsi.vue?vue&type=template&id=400b244a&scoped=true&"
import script from "./GestioneCorsi.vue?vue&type=script&lang=js&"
export * from "./GestioneCorsi.vue?vue&type=script&lang=js&"
import style0 from "./GestioneCorsi.vue?vue&type=style&index=0&id=400b244a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400b244a",
  null
  
)

export default component.exports